module.exports = __webpack_public_path__ + "static/media/bus-icon-in.44a3459d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-icon-in.svg
// module id = 658
// module chunks = 0